module.exports = __webpack_public_path__ + "img/geometric-c.dd04cfb6.png";